import React from "react";
import { PageHero, SectionWrapper } from "../../components/Section";

const LegalLayout = ({ overline, title, lead, children, testId }) => (
  <main data-testid={testId}>
    <PageHero overline={overline} title={title} lead={lead} />
    <SectionWrapper id="legal-content">
      <article className="prose-ink max-w-3xl">
        <div className="space-y-7 text-[15px] leading-relaxed text-ink-700">
          {children}
        </div>
      </article>
    </SectionWrapper>
  </main>
);

export default LegalLayout;
